try {
    document.addEventListener('DOMContentLoaded', function() {
    const timeoutDuration = 5000;
    const observer = new MutationObserver((mutationsList, observer) => {
        const checkbox = document.querySelector('.rbr-checkbox-input');
        if (checkbox) {
            checkbox.setAttribute('aria-label', 'Checkbox');
            observer.disconnect();
            clearTimeout(timeoutId);
        }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });

    const timeoutId = setTimeout(() => {
        observer.disconnect();
    }, timeoutDuration);
  }); 
} catch (error) {
  
}